var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C16.6584 22 20.5729 18.8147 21.6841 14.5033M12 22C7.34158 22 3.42713 18.8147 2.31589 14.5033M12 22C14.7614 22 17 17.5228 17 12C17 6.47715 14.7614 2 12 2M12 22C9.23858 22 7 17.5228 7 12C7 6.47715 9.23858 2 12 2M12 2C15.7391 2 18.9989 4.05216 20.7145 7.09161M12 2C8.2609 2 5.0011 4.05216 3.28547 7.09161M20.7145 7.09161C18.3775 9.11154 15.3314 10.3333 12 10.3333C8.66858 10.3333 5.62252 9.11154 3.28547 7.09161M20.7145 7.09161C21.533 8.54159 22 10.2163 22 12C22 12.8644 21.8903 13.7032 21.6841 14.5033M21.6841 14.5033C18.8149 16.0942 15.5132 17 12 17C8.48678 17 5.18514 16.0942 2.31589 14.5033M2.31589 14.5033C2.10968 13.7032 2 12.8644 2 12C2 10.2163 2.46703 8.54159 3.28547 7.09161",
    stroke: "#EDEDED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeAlt);
export default __webpack_public_path__ + "static/media/globe-alt.7180fe9d4bcf91f389b974638bf35072.svg";
export { ForwardRef as ReactComponent };